// Puente hacia sonner (el único <Toaster> montado en App.js). Antes era un stub silencioso:
// ~50 pantallas llamaban toast() y el usuario nunca veía el mensaje.
import { toast as sonnerToast } from 'sonner';

export const notify = {
  success: (message) => sonnerToast.success(message),
  error: (message) => sonnerToast.error(message),
  info: (message) => sonnerToast.info(message),
};

// API compatible con el toast de shadcn: toast({ title, description, variant })
export const toast = (options) => {
  if (typeof options === 'string') return sonnerToast(options);
  const { title, description, variant } = options || {};
  const message = title || description || '';
  const opts = title && description ? { description } : undefined;
  if (variant === 'destructive') return sonnerToast.error(message, opts);
  return sonnerToast.success(message, opts);
};
